function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { getDeepActiveElement } from './focus-utils.js';
/**
 * A controller for saving a focused node and restoring focus to it later.
 */

export var FocusRestorationController = /*#__PURE__*/function () {
  function FocusRestorationController() {
    _classCallCheck(this, FocusRestorationController);
  }

  _createClass(FocusRestorationController, [{
    key: "saveFocus",
    value:
    /**
     * Saves the given node as a target for restoring focus to
     * when `restoreFocus()` is called. If no node is provided,
     * the currently focused node in the DOM is saved as a target.
     *
     * @param {Node | null | undefined} focusNode
     */
    function saveFocus(focusNode) {
      this.focusNode = focusNode || getDeepActiveElement();
    }
    /**
     * Restores focus to the target node that was saved previously with `saveFocus()`.
     */

  }, {
    key: "restoreFocus",
    value: function restoreFocus() {
      var focusNode = this.focusNode;

      if (!focusNode) {
        return;
      }

      if (getDeepActiveElement() === document.body) {
        // In Firefox and Safari, focusing the node synchronously
        // doesn't work as expected when the overlay is closing on outside click.
        // These browsers force focus to move to the body element and retain it
        // there until the next event loop iteration.
        setTimeout(function () {
          return focusNode.focus();
        });
      } else {
        focusNode.focus();
      }

      this.focusNode = null;
    }
  }]);

  return FocusRestorationController;
}();